import "../SummaryEvaluation.css";

export default function SummaryEvaluationBox({
  studentScore = 0,
  totalScore = 0,
  feedback = "",
}) {
  const percentage =
    totalScore > 0 ? Math.round((studentScore / totalScore) * 100) : 0;

  const getStatusClass = () => {
    if (percentage >= 75) return "summary--good";
    if (percentage >= 40) return "summary--average";
    return "summary--poor";
  };

  return (
    <div className={`final-eval summary-view ${getStatusClass()}`}>
      
      {/* Score Section */}
      <div className="final-eval__score-block">
        <div className="final-eval__score-main">
          {studentScore} / {totalScore}
        </div>
        <div className="final-eval__percentage">
          {percentage}%
        </div>
      </div>

      {/* Divider */}
      <div className="final-eval__divider" />

      {/* Feedback */}
      <div className="final-eval__feedback">
        <div className="final-eval__label">Overall Feedback</div>

        {feedback ? (
          <p>{feedback}</p>
        ) : (
          <p className="final-eval__empty">No feedback provided</p>
        )}
      </div>
    </div>
  );
}